import React, { useState } from 'react';
import { getAuth, signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { database } from '../firebase';
import { ref, update } from 'firebase/database';


const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 400,
  width: '88%',
  bgcolor: 'background.paper',
  borderRadius: 'var(--r-xl)',
  boxShadow: 'var(--soft-shadow-lg)',
  p: 3,
};

const UserDisplay = ({currentPlayer, onUpdateCurrentPlayer}) => {
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [newName, setNewName] = useState(currentPlayer?.name || '');
  const auth = getAuth();
  const navigate = useNavigate();

  const handleSignOut = () => {
    signOut(auth).then(() => {
      setShowModal(false);
    }).catch((error) => {
      console.error(error);
    });
  };

  const handleNameEdit = () => {
    setEditMode(true);
  };

  const handleNameSave = async () => {
    if (newName !== currentPlayer.name) {
      currentPlayer.name = newName;
      const userRef = ref(database, `users/${currentPlayer.id}`);
      await update(userRef, { name: newName })
            .catch(error => console.error("Error updating Firestore: ", error));

      onUpdateCurrentPlayer(currentPlayer);
    }
    setEditMode(false);
  };

  const initial = (currentPlayer?.name || currentPlayer?.email || '?').trim().charAt(0).toUpperCase();

  return (
    <>
      {currentPlayer ? (
        <button
          type="button"
          className="sg-iconbtn"
          onClick={() => setShowModal(true)}
          aria-label="Account"
        >
          {currentPlayer.name || currentPlayer.email ? (
            <span
              style={{
                display: 'grid',
                placeItems: 'center',
                width: 28,
                height: 28,
                borderRadius: 'var(--r-pill)',
                background: 'var(--grape)',
                color: '#fff',
                fontFamily: 'var(--font-ui)',
                fontWeight: 900,
                fontSize: '0.95rem',
                lineHeight: 1,
              }}
            >
              {initial}
            </span>
          ) : (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <circle cx="12" cy="8" r="3.6" fill="currentColor" />
              <path d="M4.5 19.5c0-3.9 3.4-6.5 7.5-6.5s7.5 2.6 7.5 6.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" fill="none" />
            </svg>
          )}
        </button>
      ) : (
        <button
          type="button"
          className="sg-btn sg-btn--ghost sg-btn--sm"
          onClick={() => navigate('/login')}
        >
          Log in
        </button>
      )}
      <Modal
        open={showModal}
        onClose={() => setShowModal(false)}
        aria-labelledby="user-details-modal"
        aria-describedby="user-details-modal-description"
      >
        <Box sx={modalStyle} className="sg-modal-paper sg-anim-pop">
          <div className="sg-kicker" style={{ marginBottom: 6 }}>Your account</div>

          {currentPlayer && (currentPlayer.name || editMode) && (
            <div style={{ marginBottom: 18 }}>
              {editMode ? (
                <div className="sg-row" style={{ gap: 8 }}>
                  <TextField
                    value={newName}
                    onChange={(e) => setNewName(e.target.value)}
                    size="small"
                    label="Display name"
                    fullWidth
                    autoFocus
                  />
                  <button
                    type="button"
                    className="sg-btn sg-btn--mint sg-btn--sm"
                    onClick={handleNameSave}
                  >
                    Save
                  </button>
                </div>
              ) : (
                <div className="sg-row" style={{ justifyContent: 'space-between', gap: 12 }}>
                  <h3 style={{ fontSize: '1.45rem', margin: 0 }}>{currentPlayer?.name}</h3>
                  <button
                    type="button"
                    className="sg-btn sg-btn--ghost sg-btn--sm"
                    onClick={handleNameEdit}
                  >
                    Edit
                  </button>
                </div>
              )}
            </div>
          )}

          {currentPlayer && currentPlayer.email && !editMode && (
            <>
              <div className="sg-faint" style={{ fontWeight: 600, marginBottom: 22 }}>
                {currentPlayer?.email}
              </div>
              <button
                type="button"
                className="sg-btn sg-btn--ghost sg-btn--block"
                onClick={handleSignOut}
              >
                Log out
              </button>
            </>
          )}
        </Box>
      </Modal>
    </>
  );
};

export default UserDisplay;
